import { useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

const FilterOptions = ({
  tempFilterOptions,
  setTempFilterOptions,
  isFilterOptionVisible,
  setIsFilterOptionVisible,
}) => {
  const dropdownRef = useRef(null);

  // Participant options
  const participantOptions = [
    { label: "All", value: "All" },
    { label: "Participant 1", value: "p1" },
    { label: "Participant 2", value: "p2" },
    { label: "Participant 3", value: "p3" },
  ];

  // Viewer options
  const viewerOptions = [
    { label: "Select", value: "" },
    { label: "Viewer 1", value: "v1" },
    { label: "Viewer 2", value: "v2" },
    { label: "Viewer 3", value: "v3" },
  ];

  const handleChange = (name, value) => {
    setTempFilterOptions((prevOptions) => ({
      ...prevOptions,
      [name]: value,
    }));
  };

  const handleApply = () => {
    setIsFilterOptionVisible(false);
  };

  const handleReset = () => {
    const resetValues = {
      participant: "All",
      tag: "",
      note: "",
      viewer: "Select",
      segment: "",
    };
    setTempFilterOptions(resetValues);
  };

  const handleCancel = () => {
    setIsFilterOptionVisible(false);
  };

  return (
    isFilterOptionVisible && (
      <div ref={dropdownRef} className="filter-dropdown-panel shadow rounded">
        {/* Filter Options Heading */}
        <div
          className="d-flex justify-content-between align-items-center px-3 py-2"
          style={{ borderBottom: "1px solid #eee" }}
        >
          <h6 className="fw-bold text-start mb-0 fs-18">Filter Options:</h6>
          <Button
            icon="pi pi-times fs-18"
            className="p-button-text p-button-sm"
            onClick={handleCancel}
          />
        </div>

        <div className="filter-options-container p-3">
          {/* By Participant */}
          <div className="mb-3">
            <label className="form-label fw-bold text-start d-block mb-2 fs-14">
              By Participant
            </label>
            <Dropdown
              value={tempFilterOptions.participant}
              onChange={(e) => handleChange("participant", e.value)}
              options={participantOptions}
              optionLabel="label"
              optionValue="value"
              placeholder="Select Participant"
              className="w-100"
            />
          </div>

          {/* By Tag */}
          <div className="mb-3">
            <label className="form-label fw-bold text-start d-block mb-2 fs-14">
              By Tag
            </label>
            <InputText
              value={tempFilterOptions.tag}
              onChange={(e) => handleChange("tag", e.target.value)}
              placeholder="Enter tag"
              className="w-100"
            />
          </div>

          {/* By Note */}
          <div className="mb-3">
            <label className="form-label fw-bold text-start d-block mb-2 fs-14">
              By Note
            </label>
            <InputText
              value={tempFilterOptions.note}
              onChange={(e) => handleChange("note", e.target.value)}
              placeholder="Enter note"
              className="w-100"
            />
          </div>

          {/* By Viewer */}
          <div className="mb-3">
            <label className="form-label fw-bold text-start d-block mb-2 fs-14">
              By Viewer
            </label>
            <Dropdown
              value={tempFilterOptions.viewer}
              onChange={(e) => handleChange("viewer", e.value)}
              options={viewerOptions}
              optionLabel="label"
              optionValue="value"
              placeholder="Select Viewer"
              className="w-100"
            />
          </div>

          {/* By Segment */}
          <div className="mb-3">
            <label className="form-label fw-bold text-start d-block mb-2 fs-14">
              By Segment
            </label>
            <InputText
              value={tempFilterOptions.segment}
              onChange={(e) => handleChange("segment", e.target.value)}
              placeholder="Enter segment"
              className="w-100"
            />
          </div>
        </div>

        {/* Dropdown Footer with Buttons */}
        <div
          className="d-flex justify-content-end gap-2 mt-3 p-3"
          style={{ borderTop: "1px solid #eee" }}
        >
          <Button
            label="RESET"
            className="px-3 py-1 fw-bold cancel"
            onClick={handleReset}
          />
          <Button
            label="APPLY"
            className="px-3 py-1 fw-bold createClientBtn"
            onClick={handleApply}
          />
        </div>
      </div>
    )
  );
};

export default FilterOptions;
